import React, { useCallback } from 'react';
import { useReactFlow } from 'reactflow';
import {v4} from 'uuid';

export default function ContextMenu({
  id,
  top,
  left,
  right,
  bottom,
  selected,
  ...props
}) {
  const { getNode, setNodes, addNodes, setEdges } = useReactFlow();

  console.log(top);
  console.log(left);
  console.log(right);
  console.log(bottom);

  console.log("FROM ON SELECTED in CONTEXT MENU jsx");
      console.log(selected);

  const getId = () => {
    let id = v4();
    return (
      `${id}`
    )
  }
  const node = getNode(id);
  // console.log("NODE IS: ");
  // console.log(node);

  const duplicateNode = useCallback(() => {
    const node = getNode(id);
    const position = {
      x: node.position.x + 50,
      y: node.position.y + 50,
    };
 
    addNodes({
      ...node,
      selected: false,
      dragging: false,
      id: `${node.id}-copy`,
      position,
    });
  }, [id, getNode, addNodes]);


  const deleteNode = useCallback(() => {
    setNodes((nodes) => nodes.filter((node) => node.id !== id));
    setEdges((edges) => edges.filter((edge) => edge.source !== id));
  }, [id, setNodes, setEdges]);

  
  return (
    <div
      style={{ top, left, right, bottom }}
      className="context-menu"
      {...props}
    >
      <p style={{ margin: '0.5em' }}>
        <small>node: {node.data.label}</small>
      </p>
      <button onClick={duplicateNode}>Duplicate</button>
      <button onClick={deleteNode}>Delete</button>
    </div>
  );
}